/* Delivery estimate */
function calculateETA(deliveryDays, language) {
  var today = new Date();
  var deliveryDate = new Date(today);
  
  // Calculate the delivery date, skipping weekends
  var daysRemaining = deliveryDays;
  while (daysRemaining > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    var dayOfWeek = deliveryDate.getDay();
    if (dayOfWeek != 6 && dayOfWeek != 0) { // Not Saturday or Sunday
      daysRemaining--;
    }
  }

  // Set the options for the date format based on the language
  var options = {};
  if (language === 'en') {
    options = { month: 'long', day: 'numeric' };
  } else if (language === 'fr') {
    options = {  month: 'long', day: 'numeric' };
  }

  // Return the ETA as a string in the specified language and format
  return deliveryDate.toLocaleDateString(language, options);
}

// usage:
$(document).ready(function() {
  const pageUrl = window.location.href;

  function isAfter1230pmInFrance() {
    // Get the current date and time
    var now = new Date();
  
    // Set the time zone to France time
    now.setUTCHours(now.getUTCHours() + 1);
  
    // Check if it's after 12:30pm
    return now.getUTCHours() > 11 || (now.getUTCHours() == 11 && now.getUTCMinutes() >= 30);
  }
  
  // Check if it's a weekday (Monday-Friday)
  var now = new Date();
  var dayOfWeek = now.getUTCDay();
  var isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5; // Monday to Friday
  var isWeekend = dayOfWeek === 0 || dayOfWeek === 6; // Saturday or Sunday
  
  if ((isWeekday && isAfter1230pmInFrance()) || isWeekend) {
    var etaEn1 = calculateETA(2, 'en');
    var etaEn2 = calculateETA(3, 'en');
    var etaFr1 = calculateETA(2, 'fr');
    var etaFr2 = calculateETA(3, 'fr');
  } else {
    var etaEn1 = calculateETA(1, 'en');
    var etaEn2 = calculateETA(2, 'en');
    var etaFr1 = calculateETA(1, 'fr');
    var etaFr2 = calculateETA(2, 'fr');
  }
  
  if (pageUrl.includes('-uk/') || pageUrl.includes('-ch/')) {
    if ((isWeekday && isAfter1230pmInFrance()) || isWeekend) {
      var etaEn1 = calculateETA(2, 'en');
      var etaEn2 = calculateETA(3, 'en');
      var etaFr1 = calculateETA(2, 'fr');
      var etaFr2 = calculateETA(3, 'fr');
    } else {
      var etaEn1 = calculateETA(1, 'en');
      var etaEn2 = calculateETA(2, 'en');
      var etaFr1 = calculateETA(1, 'fr');
      var etaFr2 = calculateETA(2, 'fr');
    }
  } else if (pageUrl.includes('-eu/')) {
    if ((isWeekday && isAfter1230pmInFrance()) || isWeekend) {
      var etaEn1 = calculateETA(3, 'en');
      var etaEn2 = calculateETA(4, 'en');
      var etaFr1 = calculateETA(3, 'fr');
      var etaFr2 = calculateETA(4, 'fr');
    } else {
      var etaEn1 = calculateETA(2, 'en');
      var etaEn2 = calculateETA(3, 'en');
      var etaFr1 = calculateETA(2, 'fr');
      var etaFr2 = calculateETA(3, 'fr');
    }
  } else if (pageUrl.includes('-us/') || pageUrl.includes('-ca/') || pageUrl.includes('-int/')) {
    if ((isWeekday && isAfter1230pmInFrance()) || isWeekend) {
      var etaEn1 = calculateETA(4, 'en');
      var etaEn2 = calculateETA(6, 'en');
      var etaFr1 = calculateETA(4, 'fr');
      var etaFr2 = calculateETA(6, 'fr');
    } else {
      var etaEn1 = calculateETA(3, 'en');
      var etaEn2 = calculateETA(5, 'en');
      var etaFr1 = calculateETA(3, 'fr');
      var etaFr2 = calculateETA(5, 'fr');
    }
  }

  $('.deliveryNotice.onlyFR').html('&nbsp;' + etaFr1 + ' et le ' + etaFr2 );
  $('.deliveryNotice.onlyEN').html('&nbsp;' + etaEn1 + ' and ' + etaEn2  );
});


$('.openColor').click(function(){
  $('.var_colors').addClass('var_Open');
    
  setTimeout(function() { 
        $('.var_colors').addClass('hover_active');
  }, 800);
  
});

$('.openSize').click(function(){$('.var_sizes').addClass('var_Open');});
$('.openSize_shoes').click(function(){$('.var_size_sneakers').addClass('var_Open');});
$('.openLivraison').click(function(){$('.box_livraison').addClass('var_Open');});

$('.openLivraisonCart').click(function(){$('.box_livraison_cart').toggleClass('var_Open');});
$('.close').click(function(){$('.var_Open').removeClass('var_Open');});
$('body.template-product .shopify-section--featured-product .button').click(function(){$('.var_Open').removeClass('var_Open');});

$('.openPersonnalisation').click(function(){
  $('.var_personnalisation').addClass('var_Open');
  $('input#personnalisation_embossage').attr('checked', true);
});

$('.has_bandouliere').click(function(){
  setTimeout(alertFunc, 2000);
});

function alertFunc() {
  $('.bandouliere_box').addClass('var_Open');
}

/* Shoes */
$('.shoeSize').click(function(){
  var selectedSize = $(this).text();
  $('.shoeSizeValue').html(selectedSize);
});

/* color text details on hover */
$('ul.var_list.var-type-colors li').hover(
  function(){
  	var hovered = $(this).attr("data-color");
  	$('.color-active').removeClass('color-active');
  	$('p.' + hovered).addClass('color-active');
    $('p.is-active').addClass('not-active');
  }, function() {
    $('.color-active').removeClass('color-active');
    $('.not-active').removeClass('not-active');
  }
);


/* Personnalisation petite maro */
$('.validerPersonnalisation').click(function(){
  var selectedStyle = $(".var-type-personnalisation input[type='radio']:checked").val();
  var initiales = $("#personnalisation_initiales").val();
  $('.openPersonnalisation .varPrev p').html(selectedStyle + '<br>Initiales : ' + initiales);
  
  /* define preview image */
  if (selectedStyle == 'Embossage') {
    $('.openPersonnalisation .imgBox').addClass('EMB');
    $('.openPersonnalisation .imgBox').removeClass('GD');
  } else if (selectedStyle == 'Gravure dorée') {
    $('.openPersonnalisation .imgBox').removeClass('EMB');
    $('.openPersonnalisation .imgBox').addClass('GD');
  };
  
});

$('input#personnalisation_embossage').click(function(){
	$('.details_GD').removeClass('show');
  	$('.details_EMB').addClass('show');
});

$('input#personnalisation_gravure').click(function(){
	$('.details_GD').addClass('show');
  	$('.details_EMB').removeClass('show');
});

$('.countryList li').click(function(){$('.active').removeClass('active');});
$('.show-europe').click(function(){$('.detail-europe').addClass('active');$('.show-europe').addClass('active');});
$('.show-france').click(function(){$('.detail-france').addClass('active');$('.show-france').addClass('active');});
$('.show-international').click(function(){$('.detail-international').addClass('active');$('.show-international').addClass('active');});

/* MANSORRY 
function resizeGridItem(item){
  grid = document.getElementsByClassName("Product__Slideshow")[0];
  rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
  rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
  rowSpan = Math.ceil((item.querySelector('.AspectRatio').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
    item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
  allItems = document.getElementsByClassName("Product__SlideItem");
  for(x=0;x<allItems.length;x++){
    resizeGridItem(allItems[x]);
  }
}

function resizeInstance(instance){
	item = instance.elements[0];
  resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);
allItems = document.getElementsByClassName("Product__SlideItem");
*/


/* CUSTOM FILTER */
/* filter */
$(".toggle_filter").click(function(){
    $(".filter_container").toggleClass('open');
});
  
$('.filter_element.size').click(function(){
  	$('.ProductList').addClass("is_filtered");
    var filter_value = $(this).attr( "data-value" );
    
  	if ($(this).hasClass('active')) {
      	$(".size_no_visibility").removeClass("size_no_visibility");
    } else {
      $('.ProductItem').each(function() {
        if($(this).attr("data-size") != filter_value) {
          $(this).addClass("size_no_visibility");
        } else {
          $(this).removeClass("size_no_visibility");
        }
      });
    }

	if ($(this).hasClass('active')) {
      	$('.filter_element.size.active').removeClass('active');
      	$('.clear_size').removeClass('active');
    } else {
		$('.filter_element.size.active').removeClass('active');
  		$(this).addClass('active');
      	$('.clear_size').addClass('active');
    }
});
  
$('.filter_element.color').click(function(){
  	$('.ProductList').addClass("is_filtered");
    var filter_value = $(this).attr( "data-value" );
    
  	if ($(this).hasClass('active')) {
      	$(".color_no_visibility").removeClass("color_no_visibility");
    } else {
      $('.ProductItem').each(function() {
        if($(this).attr("data-color") != filter_value) {
          $(this).addClass("color_no_visibility");
        } else {
          $(this).removeClass("color_no_visibility");
        }
      });
    }

	if ($(this).hasClass('active')) {
      	$('.filter_element.color.active').removeClass('active');
      	$('.clear_color').removeClass('active');
    } else {
		$('.filter_element.color.active').removeClass('active');
  		$(this).addClass('active');
      	$('.clear_color').addClass('active');
    }
});

$('.filter_element.dispo').click(function(){
  	$('.ProductList').addClass("is_filtered");
    var filter_value = $(this).attr( "data-value" );
    
  	if ($(this).hasClass('active')) {
      	$(".dispo_no_visibility").removeClass("dispo_no_visibility");
    } else {
      $('.ProductItem').each(function() {
        if($(this).attr("data-dispo") != filter_value) {
          $(this).addClass("dispo_no_visibility");
        } else {
          $(this).removeClass("dispo_no_visibility");
        }
      });
    }

	if ($(this).hasClass('active')) {
      	$('.filter_element.dispo.active').removeClass('active');
      	$('.clear_dispo').removeClass('active');
    } else {
		$('.filter_element.dispo.active').removeClass('active');
  		$(this).addClass('active');
      	$('.clear_dispo').addClass('active');
    }
});

$('.filter_element.matiere').click(function(){
  	$('.ProductList').addClass("is_filtered");
    var filter_value = $(this).attr( "data-value" );
   
  	if ($(this).hasClass('active')) {
      	$(".matiere_no_visibility").removeClass("matiere_no_visibility");
    } else {
      $('.ProductItem').each(function() {
        if($(this).attr("data-matiere") != filter_value) {
          $(this).addClass("matiere_no_visibility");
        } else {
          $(this).removeClass("matiere_no_visibility");
        }
      });
    }

	if ($(this).hasClass('active')) {
      	$('.filter_element.matiere.active').removeClass('active');
      	$('.clear_matiere').removeClass('active');
    } else {
		$('.filter_element.matiere.active').removeClass('active');
  		$(this).addClass('active');
      	$('.clear_matiere').addClass('active');
    }
});
  
$('.clear_size').click(function(){
	$('.filter_element.size.active').removeClass('active');
	$('.clear_size').removeClass('active');
  	$('.size_no_visibility').removeClass("size_no_visibility");
});
  
$('.clear_matiere').click(function(){
	$('.filter_element.matiere.active').removeClass('active');
	$('.clear_matiere').removeClass('active');
  	$('.matiere_no_visibility').removeClass("matiere_no_visibility");
});
  
$('.clear_color').click(function(){
	$('.filter_element.color.active').removeClass('active');
	$('.clear_color').removeClass('active');
  	$('.color_no_visibility').removeClass("color_no_visibility");
});

/* entretien */
$('.preview_img').click(function(){
  	$('.active').removeClass('active');
  	var selected = $(this).attr('aria-leather');
  	$('.' + selected).addClass('active');
});

/* Initiales characters */
$(function() {
  $('#personnalisation_initiales').on('input', function() {
    this.value = this.value.replace(/[^a-zA-Z.@]/g, ''); //<-- replace all other than given set of values
  });
});

/* comparaison */
$( ".comparaisonSelect1" ).change(function() {
  var selectedProduct = $(this).val();
  $(".comparaisonProduct1").removeClass("productSelected");
  $( "div[productTitle1='" + selectedProduct + "']").addClass("productSelected");
});

$( ".comparaisonSelect2" ).change(function() {
  var selectedProduct = $(this).val();
  $(".comparaisonProduct2").removeClass("productSelected");
  $( "div[productTitle2='" + selectedProduct + "']").addClass("productSelected");
});

$(".changeImg1").click(function() {
  var imgUrl = $(this).attr("aria-image");
  var price = $(this).attr("aria-price");
  var link =  "https://www.leoetviolette.com/products/" + $(this).attr("aria-url");
  $('.comparaisonContainer1 .productSelected').find('.productImage').attr("src",imgUrl);
  $('.comparaisonContainer1 .productSelected').find('.productPrice').html(price);
  $('.comparaisonContainer1 .productSelected').find('.productLink').attr("href",link);
});

$(".changeImg2").click(function() {
  var imgUrl = $(this).attr("aria-image");
  var price = $(this).attr("aria-price");
  var link =  "https://www.leoetviolette.com/products/" + $(this).attr("aria-url");
  $('.comparaisonContainer2 .productSelected').find('.productImage').attr("src",imgUrl);
  $('.comparaisonContainer2 .productSelected').find('.productPrice').html(price);
  $('.comparaisonContainer2 .productSelected').find('.productLink').attr("href",link);
});


/* Remove price decimals */
$(document).ready(function() {
    $('sale-price').each(function() {
        var textContent = $(this).text();
        
        // Replace occurrences of ".00" at the end of a number in the text content
        var updatedTextContent = textContent.replace(/(\d+)\.00\b/g, '$1');
        $(this).text(updatedTextContent);
    });
});


/* product read more */
$(document).ready(function () {
  var $description = $('.product-info__block-item[data-block-type="description"] .prose');

  if ($description.length === 0) return;
  if ($(window).width() > 768) return; // Only apply on mobile

  var maxHeight = 78; // px

  if ($description[0].scrollHeight > maxHeight) {
    $description.addClass('truncated-description');

    var $btn = $('<button/>', {
      text: '... Voir plus',
      class: 'read-more-toggle'
    });

    $description.parent().append($btn);

    $btn.on('click', function () {
      $description.toggleClass('open');
      $btn.toggleClass('open');

      var isOpen = $description.hasClass('open');
      $btn.text(isOpen ? 'Voir moins' : '... Voir plus');
    });
  }
});





